<template>
  <sf-modal
    v-if="modalOpen"
    class-name="sf-border-box"
    size="xs"
    @close="close"
  >
    <template #title>
      <span v-if="loading">{{ I18n.t('common.loading') }}</span>
      <span v-else>
        <span v-if="children.length === 0">{{
          I18n.t('templates.not_used')
        }}</span>
        <span v-if="children.length > 0">{{
          I18n.t('templates.used_x_times', { count: children.length })
        }}</span>
      </span>
    </template>

    <template #messages>
      <SfModalMessage v-if="error" variant="error"
        >{{ I18n.t('common.error.try_again') }}
      </SfModalMessage>
    </template>

    <template #body>
      <div class="sf-below-2">
        <input
          v-model="filter"
          class="sf-form-input sf-full-width"
          :placeholder="I18n.t('js.quick_search.search_for')"
        />
      </div>

      <div class="template-modal__scroller-container">
        <div v-if="!error && loading" class="sf-level sf-level-around">
          <div class="sf-spinner sf-inline-block" />
        </div>

        <sf-virtual-table
          v-else-if="!error && filteredChildren.length > 0"
          :items="filteredChildren"
          :item-size="37"
          :row-size="rowSize"
          key-field="link"
        >
          <template #header>
            <sf-virtual-table-header-cell>{{
              I18n.t('common.company_name')
            }}</sf-virtual-table-header-cell>
            <sf-virtual-table-header-cell v-if="hasUpdatedAt">{{
              I18n.t('common.last_update')
            }}</sf-virtual-table-header-cell>
          </template>

          <template #default="{ item, active }">
            <sf-virtual-table-data-row
              :active="active"
              :item="item"
              :size-dependencies="[item.link]"
              :row-size="rowSize"
            >
              <sf-virtual-table-data-cell>
                <span v-dompurify-html="item.link" />
              </sf-virtual-table-data-cell>
              <sf-virtual-table-data-cell v-if="hasUpdatedAt">
                {{ item.updatedAt }}
              </sf-virtual-table-data-cell>
            </sf-virtual-table-data-row>
          </template>
        </sf-virtual-table>
      </div>
    </template>
  </sf-modal>
</template>

<script>
import { SfLog } from '@app/adapters/logger'
import { SfModal, SfModalMessage } from '@app/shared/vue/components/sf-modal'
import SfVirtualTable from '@app/shared/vue/components/sf-virtual-table/sf-virtual-table'
import SfVirtualTableHeaderCell from '@app/shared/vue/components/sf-virtual-table/sf-virtual-table-header-cell'
import SfVirtualTableDataCell from '@app/shared/vue/components/sf-virtual-table/sf-virtual-table-data-cell'
import SfVirtualTableDataRow from '@app/shared/vue/components/sf-virtual-table/sf-virtual-table-data-row'

import SFetch from '@app/utils/sfetch'

export default {
  components: {
    SfModal,
    SfModalMessage,
    SfVirtualTable,
    SfVirtualTableHeaderCell,
    SfVirtualTableDataCell,
    SfVirtualTableDataRow,
  },

  data() {
    return {
      children: [],
      loading: false,
      error: false,
      modalOpen: false,
      filter: '',
    }
  },

  computed: {
    filteredChildren() {
      if (this.filter && this.filter.length > 0) {
        const lowerFilter = this.filter.toLowerCase()

        return this.children.filter((child) => {
          return child.name.toLowerCase().includes(lowerFilter)
        })
      } else {
        return this.children
      }
    },
    hasUpdatedAt() {
      return !this.children.find((child) => !child.updatedAt)
    },
    rowSize() {
      return this.hasUpdatedAt ? 2 : 1
    },
  },

  methods: {
    async openModal(context) {
      this.modalOpen = true
      this.filter = ''
      await this.getChildren(context.url)
    },

    close() {
      this.error = false
      this.loading = false
      this.modalOpen = false
    },

    async getChildren(url) {
      this.loading = true

      try {
        this.children = await SFetch.json(url, { method: 'GET' })
        this.loading = false
      } catch (e) {
        SfLog.warn('Error fetching children', { extra: { error: e } })

        this.loading = false
        this.error = e
      }
    },
  },
}
</script>

<style scoped>
.template-modal__scroller-container {
  height: min(50vh, 400px);
  overflow-y: scroll;
}
</style>
